import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import { Box } from '@amzn/awsui-components-react-v3';

import { Context } from '../../../store';
import { Model, ReceiveType, ReceiveTypeNameMap, ReferenceQueryResponseItem } from '../../../store/types';
import CopyText from '../../CopyText';
import { getOrderLineItemNumber, getOrderNumber } from '../../Utils/Utils';

interface OrderTypeProps {
  model: Model;
}

export const OrderID = ({ model }: OrderTypeProps) => {
  const { state } = useContext(Context);
  const { referenceId } = useParams();

  const references: ReferenceQueryResponseItem[] = state?.receiveReferences || [];
  const reference = references.find(
    (ref: ReferenceQueryResponseItem) => ref.receiveReference.receiveReferenceId === referenceId,
  );

  const isPO = reference?.receiveReference.externalReferenceType === ReceiveType.AWS_PO;
  const orderNumber = isPO ? reference?.receiveReference.externalReferenceValue : getOrderNumber({ model });

  return (
    <Box>
      {orderNumber ? (
        <CopyText value={orderNumber || ''} label="orderID">
          {orderNumber}
        </CopyText>
      ) : null}
    </Box>
  );
};

export const OrderLineItemNumber = ({ model }: OrderTypeProps) => {
  const lineItemNumber = getOrderLineItemNumber({ model });
  return <Box>{lineItemNumber ? lineItemNumber : null}</Box>;
};

export const OrderName = ({ model }: OrderTypeProps) => {
  const getOrderName = () => {
    switch (model.externalReferenceType) {
      case ReceiveType.ASN_JANUS: {
        return ReceiveTypeNameMap[ReceiveType.ASN_JANUS];
      }
      case ReceiveType.ASN_AWS_OWNED_INVENTORY_RO: {
        return ReceiveTypeNameMap[ReceiveType.ASN_AWS_OWNED_INVENTORY_RO];
      }
      case ReceiveType.ASN_RMA: {
        return ReceiveTypeNameMap[ReceiveType.ASN_RMA];
      }
      case ReceiveType.ASN_WW_FA: {
        return ReceiveTypeNameMap[ReceiveType.ASN_WW_FA];
      }
      case ReceiveType.ASN_OMD: {
        return ReceiveTypeNameMap[ReceiveType.ASN_OMD];
      }
      case ReceiveType.AWS_PO:
      case ReceiveType.ASN_AWS_PO: {
        return ReceiveTypeNameMap[ReceiveType.ASN_AWS_PO];
      }
      default:
        return null;
    }
  };

  return <Box>{getOrderName()}</Box>;
};
